import React from 'react';
import exact from 'prop-types-exact';

import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';
import FiltersPanel from './containers/FiltersPanel';
import SummaryBonusWrapper from './containers/SummaryBonusWrapper';

import { routerProps } from '../../propTypes';

const propTypes = exact({
  ...routerProps,
});

const BonusSummaryPage = (props) => {
  return (
    <div>
      <PageLayout
        title="Bonus Summary"
        render={() => {
          return (
            <SplitLayout
              leftSize={2}
              leftRender={() => { return <FiltersPanel />; }}
              rightSize={10}
              rightRender={() => { return <SummaryBonusWrapper />; }}
            />
          );
        }}
      />
    </div>
  );
};


BonusSummaryPage.propTypes = propTypes;

export default BonusSummaryPage;
